import React, {useEffect} from 'react';
import { IonButton, IonInput, IonItem, IonList } from '@ionic/react';
import { useTranslation } from 'react-i18next';
import './AddPhysicalFarecardForm.css';
import VisualFarecard from './VisualFarecard';
import { uiInputMode } from '../../utils/ui';
import {formatCreditCard} from "../../utils/strings";

type AddPhysicalFarecardFormProps = {
  isValid: boolean;
  number: string;
  cardLength: number;
  setNumber: (s: string) => void;
  code: string;
  setCode: (s: string) => void;
  name: string;
  setName: (s: string) => void;
  proceed: () => void;
};

export default function AddPhysicalFarecardForm({
  isValid,
  number,
  cardLength,
  setNumber,
  code,
  setCode,
  name,
  setName,
  proceed,
}: AddPhysicalFarecardFormProps) {
  const [t] = useTranslation('global');

  const [formattedNumber, setFormattedNumber] = React.useState<string>(formatCreditCard(number));

  const handleNumberChange = (value: string) => {
    value = value.replace(/ /g, '');
    setNumber(value);
  }

  useEffect(() => {
    setFormattedNumber(formatCreditCard(number).trim())
  }, [number]);

  return (
    <>
      <div className="ion-text-center farcards-physical">
        <VisualFarecard item={{ isVirtualCard: false, nickname: name }} newCard={true} />
      </div>
      <h1 className="h1 pt-5">{t('farecards.physicalinfo')}</h1>
      <p className="h1 pt-2 instructions">{t('farecards.physicaldetails')}</p>
      <IonList inset={false}>
        <IonItem lines="none" className="ion-no-padding ion-pt-1">
          <IonInput
            value={formattedNumber}
            mode={uiInputMode()}
            aria-label={t('farecards.physicalnumber')!}
            placeholder={t('farecards.physicalnumber')!}
            onIonInput={(e) => handleNumberChange(e.detail.value!)}
            type="text"
            fill="outline"
          ></IonInput>
        </IonItem>
        <IonItem lines="none" className="ion-no-padding form-field-hint">
          {t('farecards.hintphysicalnumber', { v: cardLength })}
        </IonItem>
        <IonItem lines="none" className="ion-no-padding">
          <IonInput
            value={code}
            mode={uiInputMode()}
            aria-label={t('farecards.physicalcode')!}
            placeholder={t('farecards.physicalcode')!}
            onIonInput={(e) => setCode(e.detail.value!)}
            type="text"
            fill="outline"
          ></IonInput>
        </IonItem>
        <IonItem lines="none" className="ion-no-padding form-field-hint">
          {t('farecards.hintphysicalcode')}
        </IonItem>
        <IonItem lines="none" className="ion-no-padding">
          <IonInput
            value={name}
            mode={uiInputMode()}
            aria-label={t('farecards.name')!}
            placeholder={t('farecards.name')!}
            onIonInput={(e) => setName(e.detail.value!)}
            type="text"
            fill="outline"
          ></IonInput>
        </IonItem>
        <IonItem lines="none" className="ion-no-padding form-field-hint">
          {t('farecards.hintname')}
        </IonItem>
      </IonList>

      <div className="pt-3 ion-text-center">
        <IonButton
          className={
            'btn-default btn-wide-80 ' + (isValid ? '' : 'btn-disabled')
          }
          onClick={() => proceed()}
        >
          {t('farecards.addcard')}
        </IonButton>
      </div>
    </>
  );
}
